<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- <li class="nav-item">
        <sidenav-item 
          url="/dashboard-default"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >

          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-item
          url="/dashboard-member"
          :class="getRoute() === 'dashboard-member' ? 'active' : ''"
          :navText="'Dashboard Members'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-02 text-primary text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li> -->
      <li class="nav-item">
        <sidenav-item
          url="/user"
          :class="getRoute() === 'user' ? 'active' : ''"
          :navText="'User'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-02 text-primary text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <!-- 
      <li class="nav-item" v-show="is_admin">
        <sidenav-item
          url="/tables"
          :class="getRoute() === 'tables' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Members'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-02 text-info text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li> -->
      <li class="nav-item" v-show="!is_admin">
        <sidenav-item
          url="/referral_extra"
          :class="getRoute() === 'referral_extra' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Member'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-02 text-info text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-show="is_admin">
        <sidenav-item
          url="/influencers"
          :class="getRoute() === 'influencers' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Influencers'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-02 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <!-- <li class="nav-item" v-show="is_admin">
        <sidenav-item
          url="/billing"
          :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتیر' : 'Income'"
        >
          <template v-slot:icon>
            <i class="ni ni-money-coins text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->



      <li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'حساب تعريفي' : 'Config'"
        >
          <template v-slot:icon>
            <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

    </ul>
  </div>

</template>
<script>
/* eslint-disable */
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      is_admin : false
    };
  },
  components: {
    SidenavItem,
    SidenavCard
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    }
  }, 
  mounted () {
    var user = window.localStorage.getItem('$logged_user');
    console.log('us : ' + user )
    if (user == 'admin')
      this.is_admin = true;
  }
};
</script>
